import { Badge } from "@/components/ui/badge";
import {
  ContractStatus,
  statusIcon,
  statusText,
  statusVariant,
} from "@/utils/status-transport";
import { Separator } from "@radix-ui/react-separator";

interface ContractCardProps {
  id: string;
  from: string;
  to: string;
  vehicle: string;
  plate: string;
  status: ContractStatus;
  nextStep: string;
  onViewMore?: () => void;
  separator?: boolean;
}

export default function ContractCard({
  id,
  from,
  to,
  vehicle,
  plate,
  status,

  separator = true,
}: ContractCardProps) {
  return (
    <div className="flex flex-col gap-4">
      <span className="font-semibold text-n-text-primary text-sm">
        Contrato nº&nbsp;{id}
      </span>

      <div className="flex flex-col md:flex-row lg:w-[80%] sm:w-[90%] w-[100%] justify-between text-sm gap-4">
        <div className="flex flex-col gap-1">
          <span className="font-semibold text-n-text-primary">De:</span>
          <span className="text-n-text-neutral">{from}</span>
        </div>

        <div className="flex flex-col gap-1">
          <span className="font-semibold text-n-text-primary">Para:</span>
          <span className="text-n-text-neutral">{to}</span>
        </div>

        <div className="flex flex-col gap-1">
          <span className="font-semibold text-n-text-primary">Veículo:</span>
          <span className="text-n-text-neutral">{vehicle}</span>
        </div>

        <div className="flex flex-col gap-1">
          <span className="font-semibold text-n-text-primary">Placa:</span>
          <span className="text-n-text-neutral">{plate}</span>
        </div>
      </div>

      <div className="flex flex-col md:flex-row lg:w-[80%] sm:w-[90%] w-[100%] justify-between text-sm gap-4">
        <div className="flex flex-col gap-1  md:col-span-4">
          <span className="font-semibold text-n-text-primary">Status:</span>
          <Badge
            className="text-sm font-normal rounded-full gap-2 w-fit"
            variant={statusVariant[status]}
          >
            {statusText[status]}
            {statusIcon[status]}
          </Badge>
        </div>

        {/* <div className="flex flex-col gap-1 md:col-span-4">
          <span className="font-semibold text-n-text-primary">
            Próxima etapa:
          </span>
          <span className="text-n-text-neutral">{nextStep}</span>
        </div> */}
      </div>

      {separator && <Separator />}
    </div>
  );
}
